import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { DesktopHeaderComponent } from "../../../general-components/desktop-header/desktop-header.component";
import { FilterSearchComponent } from "../../../general-components/filter-search/filter-search.component";
import { AppService } from 'src/app/services/app.service';

@Component({
    selector: 'app-consultant-overview',
    templateUrl: './consultant-overview.page.html',
    styleUrls: ['./consultant-overview.page.scss'],
    standalone: true,
    imports: [
        IonicModule,
        DesktopHeaderComponent,
        FilterSearchComponent
    ]
})
export class ConsultantOverviewPage {

    public isGRB = this.app.isGRB();

    constructor(
        private app: AppService,
    ) { }
}
